export const locationsRoutes = {
  'api.locations.province-list': 'locations/province-list',
  'api.locations.city-list': 'locations/city-list',
};
